import { render, staticRenderFns } from "./newApp.vue?vue&type=template&id=b396ed30&scoped=true&"
import script from "./newApp.vue?vue&type=script&lang=js&"
export * from "./newApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b396ed30",
  null
  
)

export default component.exports